import { Action, initialState, State } from "store/store";

export const setError = (state: State = initialState, { data }: Action) => {
  return {
    ...state,
    hasError: true,
    error: data,
  };
};
